import { LossOfUseStatusSchema, LossOfUseTypeSchema } from '@eigtech/claims-v2-types';
import { ContactCornSchema } from '@eigtech/contacts-types';
import { CurrentClaimCornSchema } from '@eigtech/shared-corn-helper';
import { z } from 'zod';
import { makeSummaryFilterSchema, makeSummaryParamsSchema } from './pagination.js';
export const ClaimSummarySchema = z.object({
    carrier: z.string().optional(),
    catCode: z.string().optional(),
    claimNumber: z.string(),
    claimStatus: z.string().optional(),
    coordinator: z
        .object({
        id: ContactCornSchema,
        name: z.string().optional(),
    })
        .optional(),
    dataSource: z.string().optional(),
    dateReceived: z.string().optional(),
    deskAdjuster: z
        .object({
        id: ContactCornSchema,
        name: z.string().optional(),
    })
        .optional(),
    fieldAdjuster: z
        .object({
        id: ContactCornSchema,
        name: z.string().optional(),
    })
        .optional(),
    hasJob: z.boolean(),
    hasLegalRep: z.boolean(),
    hasLossOfUseReceipts: z.boolean().optional(),
    id: CurrentClaimCornSchema,
    inAssignQueue: z.string().optional(),
    inspectionCompleted: z.string().optional(),
    inspectionScheduleConfirmed: z.string().optional(),
    inspectionScheduled: z.string().optional(),
    inspectionTechnician: z
        .object({
        id: ContactCornSchema,
        name: z.string().optional(),
    })
        .optional(),
    isReadOnly: z.boolean().optional(),
    latestTimelineEvent: z.string().optional(),
    lossDate: z.string().optional(),
    lossLocation: z.object({
        city: z.string(),
        state: z.string(),
        county: z.string().optional(),
    }),
    lossOfUseStatus: LossOfUseStatusSchema.array().optional(),
    lossOfUseType: LossOfUseTypeSchema.array().optional(),
    policyHolder: z
        .object({
        name: z.string(),
        phone: z.string().optional(),
        email: z.string().optional(),
    })
        .optional(),
    primaryContact: z
        .object({
        name: z.string(),
        phone: z.string().optional(),
        email: z.string().optional(),
    })
        .optional(),
    reviewer: z
        .object({
        id: ContactCornSchema,
        name: z.string().optional(),
    })
        .optional(),
});
export const ClaimSummaryFieldSchema = z.enum([
    'addressType',
    'carrier',
    'carrierId',
    'catCode',
    'city',
    'claimNumber',
    'claimReviewers',
    'claimStatus',
    'coordinatorId',
    'coordinatorName',
    'county',
    'dataSource',
    'dateOfLoss',
    'dateReceived',
    'deskAdjusterId',
    'deskAdjusterName',
    'fieldAdjusterId',
    'fieldAdjusterName',
    'hasCatCode',
    'hasClaimReview',
    'hasCoordinator',
    'hasDeskAdjuster',
    'hasFieldAdjuster',
    'hasInspectionTechnician',
    'hasInitialClaimAction',
    'hasJob',
    'hasLegalRep',
    'hasLossOfUse',
    'inAssignQueue',
    'inspectionCompleted',
    'inspectionScheduled',
    'inspectionScheduleConfirmed',
    'isReadOnly',
    'jobContracted',
    'jobNotSold',
    'latestTimelineEvent',
    'lossDate',
    'lossType',
    'policyHolderEmail',
    'policyHolderName',
    'policyHolderPhone',
    'primaryContactEmail',
    'primaryContactName',
    'primaryContactPhone',
    'reviewerId',
    'reviewerName',
    'severity',
    'state',
    'inspectionsStatus',
    'inspectionTechnicianId',
    'inspectionTechnicianName',
]);
export const ClaimSummaryFilterSchema = makeSummaryFilterSchema(ClaimSummaryFieldSchema);
export const ClaimSummariesParamsSchema = makeSummaryParamsSchema(ClaimSummaryFieldSchema, ClaimSummaryFilterSchema);
